'use strict';

var React = require('react');
var index = require('../Flex/index.js');
var component = require('../Icon/component.js');
require('../Tooltip/component.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const Stepper = React.forwardRef(({ children, activeStep, ...props }, ref) => (React__default.default.createElement(index.Flex.Row, { ...props, space: "l", ref: ref }, React.Children?.map(children, (child, index) => (React__default.default.createElement(React__default.default.Fragment, null,
    index !== 0 && React__default.default.createElement(component.Icon, { name: "next-filled" }),
    React__default.default.cloneElement(child, {
        index,
        active: index === activeStep,
    })))))));

exports.Stepper = Stepper;
//# sourceMappingURL=component.js.map
